// extracted by mini-css-extract-plugin
export var fadein = "index-module--fadein--wF9Ir";
export var main = "index-module--main--Fw+WE";